const safeParseInt = (value, defaultValue = 0) => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? defaultValue : parsed;
};

const safeParseFloat = (value, defaultValue = 0) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? defaultValue : parsed;
};

const buildPackagePrices = (pkg, groups, hasGroups, capacity) => (
  groups.map((group) => {
    const groupId = hasGroups ? group.id : 'all';
    const price = (pkg.prices && pkg.prices[groupId]) || '0';

    return {
      minPersons: safeParseInt(group.from, 1),
      maxPersons: safeParseInt(group.to, capacity),
      price: safeParseFloat(price, 0),
    };
  })
);

export const buildPricingUpdateFields = (editorStudioData = {}) => {
  const pricingType = editorStudioData.pricingType;
  const isPackages = pricingType === 'paketpreise';
  const capacity = safeParseInt(editorStudioData.capacity, 20);

  const backendData = {
    pricingMode: isPackages ? 'PACKAGES' : 'HOURLY',
  };

  if (isPackages) {
    backendData.pricePerHour = null;
    backendData.minNumberOfHours = null;
    backendData.tieredPricing = null;

    if (Array.isArray(editorStudioData.packages) && editorStudioData.packages.length > 0) {
      const hasGroups = editorStudioData.adjustPriceByPeople && editorStudioData.priceGroups?.length > 0;
      const groups = hasGroups
        ? editorStudioData.priceGroups
        : [{
            id: 'all',
            from: 1,
            to: capacity,
          }];

      backendData.packages = editorStudioData.packages.map((pkg) => ({
        id: pkg.id,
        name: pkg.name,
        durationHours: safeParseInt(pkg.hours, 0),
        prices: buildPackagePrices(pkg, groups, hasGroups, capacity),
      }));
    } else {
      backendData.packages = null;
    }
  } else {
    backendData.packages = null;

    if (editorStudioData.adjustPriceByPeople && editorStudioData.priceGroups?.length > 0) {
      backendData.pricePerHour = null;
      backendData.tieredPricing = editorStudioData.priceGroups.map((group) => ({
        minPersons: safeParseInt(group.from, 1),
        maxPersons: safeParseInt(group.to, capacity),
        pricePerHour: safeParseFloat(group.price, 0),
      }));
    } else {
      backendData.tieredPricing = null;
      backendData.pricePerHour = editorStudioData.pricePerHour
        ? safeParseFloat(editorStudioData.pricePerHour, 0)
        : null;
    }

    if (editorStudioData.minNumberOfHours) {
      backendData.minNumberOfHours = safeParseInt(editorStudioData.minNumberOfHours, 0);
    }
  }

  if (editorStudioData.discounts?.length > 0) {
    backendData.discountRules = editorStudioData.discounts.map((discount) => ({
      minHours: safeParseInt(discount.minHours, 0),
      discountType: discount.discountType === 'percentage' ? 'PERCENTAGE' : 'FIXED',
      discountValue: safeParseFloat(discount.discountValue, 0),
    }));
  } else if (Array.isArray(editorStudioData.discounts) && editorStudioData.discounts.length === 0) {
    backendData.discountRules = null;
  }

  if (editorStudioData.weekendSurcharge && editorStudioData.weekendDays && editorStudioData.weekendDays.length > 0) {
    const saturday = editorStudioData.weekendDays.find((day) => day.day === 'Samstag');
    const sunday = editorStudioData.weekendDays.find((day) => day.day === 'Sonntag');

    backendData.weekendSurcharge = {
      saturdayEnabled: !!saturday,
      saturdaySurchargeType: saturday ? (editorStudioData.weekendMode === 'percentage' ? 'PERCENTAGE' : 'FIXED') : null,
      saturdaySurchargeValue: saturday ? safeParseFloat(saturday.percent, 0) : null,
      sundayEnabled: !!sunday,
      sundaySurchargeType: sunday ? (editorStudioData.weekendMode === 'percentage' ? 'PERCENTAGE' : 'FIXED') : null,
      sundaySurchargeValue: sunday ? safeParseFloat(sunday.percent, 0) : null,
    };
  } else if (editorStudioData.weekendSurcharge === false) {
    backendData.weekendSurcharge = null;
  }

  if (editorStudioData.fees?.length > 0) {
    backendData.extraFees = editorStudioData.fees.map((fee) => ({
      id: fee.id,
      name: fee.description || '',
      amount: safeParseFloat(fee.amount, 0),
    }));
  } else if (Array.isArray(editorStudioData.fees) && editorStudioData.fees.length === 0) {
    backendData.extraFees = null;
  }

  if (editorStudioData.productionAreaSize) {
    backendData.productionAreaSize = editorStudioData.productionAreaSize;
  }

  return backendData;
};
